export default "__VITE_ASSET__d80f3615__"